
 export class ImageDataReader {
    imgData = null;

    constructor(imgData) {
        this.imgData = imgData;
    }

    outOfRange(i, j) {
        return i < 0 || i >= this.imgData.width || j < 0 || j >= this.imgData.height;
    }

    getGrayAt(i, j) {
        let gray;
        if (this.outOfRange(i, j)) {
            gray = 0;
        } else {
            let index = (j * this.imgData.width + i) * 4;
            // gray = this.imgData.data[index];
            gray = 0.299 * this.imgData.data[index] + 0.587 * this.imgData.data[index + 1] + 0.114 * this.imgData.data[index + 2];
        }
        return gray;
    }

    getGrayValue(x, y) {
        let x0 = Math.floor(x);
        let y0 = Math.floor(y);
        let dx = x - x0;
        let dy = y - y0;
        let gray00 = this.getGrayAt(x0, y0);
        let gray10 = this.getGrayAt(x0 + 1, y0);
        let gray11 = this.getGrayAt(x0 + 1, y0 + 1);
        let gray01 = this.getGrayAt(x0, y0 + 1);
        let gray0 = gray00 * (1 - dx) + gray10 * dx;
        let gray1 = gray01 * (1 - dx) + gray11 * dx;
        let gray = gray0 * (1 - dy) + gray1 * dy;
        return gray / 255.0;
    }
}



// WEBPACK FOOTER //
// ./src/views/reliefVase/scripts/ImageDataReader.js